import React, { ChangeEvent, FC, useState } from "react";
import validator from "validator";

import { Stack, Typography } from "@mui/material";

import TextField from "../../../components/styled/TextField";
import {
  getSettingsFormProperty,
  setSettingsFormError,
  setSettingsFormProperty,
} from "../../../slices/settings";
import { useDispatch, useSelector } from "../../../store";

function validate(url: string): string {
  if (
    validator.isURL(url, {
      allow_query_components: false,
      allow_fragments: false,
    })
  ) {
    return "";
  }
  return "Please enter a valid URL";
}

type AuthenticateServiceUrlProps = {
  readonly: boolean;
};
const AuthenticateServiceUrl: FC<AuthenticateServiceUrlProps> = ({
  readonly,
}) => {
  const dispatch = useDispatch();
  const authenticateServiceUrl = useSelector(
    getSettingsFormProperty("authenticateServiceUrl", undefined),
  ) as string;
  const [errorText, setErrorText] = useState(
    authenticateServiceUrl ? validate(authenticateServiceUrl) : "",
  );
  let displayedAuthenticateServiceUrl = "";
  if (authenticateServiceUrl?.startsWith("https://")) {
    displayedAuthenticateServiceUrl = authenticateServiceUrl.substring(
      "https://".length,
    );
  }

  const handleChange = (evt: ChangeEvent<HTMLInputElement>) => {
    const url = `https://${evt.target.value}`;
    const error = validate(url);
    setErrorText(error);
    dispatch(setSettingsFormError({ path: "authenticateServiceUrl", error }));
    dispatch(
      setSettingsFormProperty({
        path: "authenticateServiceUrl",
        value: evt.target.value ? url : undefined,
      }),
    );
  };

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="baseline"
      sx={{ width: "100%" }}
    >
      <Typography>https://</Typography>
      <TextField
        value={displayedAuthenticateServiceUrl}
        onChange={handleChange}
        InputProps={{ readOnly: readonly }}
        error={!!errorText}
        helperText={errorText}
        fullWidth
      />
    </Stack>
  );
};
export default AuthenticateServiceUrl;
